import axios from 'axios';
import config from '../../config';

class QueryApi {

	static getBaseURL() {
		return localStorage.apiDomain || config.api;
    }

	static getInstance() {
        const instance = axios.create({
            baseURL: this.getBaseURL(),
            headers: {
                'Content-Type': 'application/json',
				'x-craffview-env': config.apiHeaderXCraffviewEnv
            },
			// withCredentials: true,
        });

        instance.interceptors.response.use(
            response => response,
            error => {
                return Promise.reject(error);
            }
        );

        return instance;
    }

	static get(path) {
		const queryInstance = this.getInstance();
		queryInstance.defaults.headers['cv-key'] = localStorage.apiKey;
		return queryInstance.get(path)
			.then(function (response) {
				return response.data;
			})
			.catch(function (error) {
				throw (error);
			});
	}
	static post(path, payload) {
		const queryInstance = this.getInstance();
		queryInstance.defaults.headers['cv-key'] = localStorage.apiKey;
		// queryInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();
		return queryInstance.post(path, payload)
			.then(function (response) {
				return response.data;
			})
			.catch(function (error) {
				throw (error);
			});
	}
	static patch(path, payload) {
		const queryInstance = this.getInstance();
		queryInstance.defaults.headers['cv-key'] = localStorage.apiKey;
		// queryInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();
		return queryInstance.patch(path, payload)
			.then(function (response) {
				return response.data;
			})
			.catch(function (error) {
				throw (error);
			});
	}
	static delete(path, payload) {
		const queryInstance = this.getInstance();
		queryInstance.defaults.headers['cv-key'] = localStorage.apiKey;
		// queryInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();
		return queryInstance.delete(path, payload)
			.then(function (response) {
				return response.data;
			})
			.catch(function (error) {
				throw (error);
			});
	}
}


export default QueryApi;
